import "../servise.scss";
import ServiseFooter from "./servise_footer";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
const ServiseAtv = () => {
  return (
    <div className="servise-page">
      <>
          <Helmet>
              <title>Pro Moto - serwis quadów / ATV</title>
              <meta
              name="description"
              content="PRO MOTO Oferujemy kompleksowy serwis quadów / ATV"
              />
              <link rel="canonical" href="https://promotoserwis.pl/serwis-quadow" />
          </Helmet>
      </>
      <section className="servise-hero">
        <div className="servise-hero__content">
          <motion.h1
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}>SERWIS QUADÓW / ATV</motion.h1>
          <motion.h2
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
              Szuter, błoto i kamienie są dla Ciebie frajdą, 
              ale dla Twojego quada to ciężka próba. W PRO MOTO przywracamy ATV-y do pełnej 
              sprawności – bezpiecznie, terminowo.
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
            <strong>Przed wstawieniem na serwis prosimy o umycie pojazdu.</strong>
          </motion.p>

          <button
            className="servise-scroll-btn"
            onClick={() =>
              document.querySelector(".servise-extra").scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            <span className="arrow"></span>
          </button>
        </div>
      </section>

      <section className="servise-extra">
        <div className="servise-extra__container">

          <div className="servise-block">
            <h3 className="servise-block_title">Zakres usług</h3>
          </div>

          <div className="servise-block">
            <h2>Silnik, układ paliwowy</h2>
            <ul>
              <li>Wymiana oleju i filtrów, regulacje zaworów</li>
              <li>Płukanie baku, czyszczenie gaźników / wtrysku z piachu i mułu</li>
            </ul>
          </div>

          <div className="servise-block">
            <h2>Napęd, przekładnia</h2>
            <ul>
              <li>Serwis krzyżaków, przegubów, półosi oraz wału Kardana</li>
              <li>Wymiana pasków CVT, kół zębatych i łożysk napędu</li>
            </ul>
          </div>

          <div className="servise-block">
            <h2>Zawieszenie, kierownica</h2>
            <ul>
              <li>Regeneracja amortyzatorów, wymiana drążków i sworzni</li>
              <li>Ustawianie geometrii i sprawdzanie zbieżności</li>
            </ul>
          </div>

          <div className="servise-block">
            <h2>Układ hamulcowy</h2>
            <ul>
              <li>Klocki, tarcze, regeneracja zacisków</li>
              <li>Płukanie i wymiana płynu hamulcowego</li>
            </ul>
          </div>

          <div className="servise-block">
            <h2>Łożyska, koła</h2>
            <ul>
              <li>Demontaż, montaż i smarowanie łożysk kół</li>
              <li>Wyważanie opon terenowych</li>
            </ul>
          </div>
          <ServiseFooter/>

        </div>
      </section>
    </div>
  );
};

export default ServiseAtv;
